import { user as types } from '../../constants/types'
const user = {
    users: [],
    user: {},
    loading: false,
    error: null
}
const reducer = (state = user, action) => {
    switch (action.type) {
        case types.GET: return { ...state, users: action.payload };
        case types.USER: return { ...state, user: action.payload };
        case types.PUSH:
            return { ...state, user: action.payload, users: [...state.users, action.payload] };
        case types.LOADING: return { ...state, loading: !state.loading };
        case types.ERROR: return { ...state, error: action.payload };
        default: return state;
    }
}
export default reducer